/**
 * Cognito-email → mapped-tester-name lookup utilities.
 *
 * The admin project report exposes a "Cognito User" multi-select populated
 * from `useTesters()` (the list of all Cognito users). When a user is
 * selected, we try to resolve their email to the project's mapped
 * test-person name (stored in `report.tester_emails: { [name]: email }`)
 * so the backend filter sees the name that appears on TEST_CASE rows.
 *
 * The lookup is case-insensitive because Cognito and USER_MAPPING can
 * store the same email with divergent casing (e.g.
 * `maarten.Buytaert@lotusbakeries.com` vs
 * `Maarten.Buytaert@Lotusbakeries.com`), and emails are case-insensitive
 * per RFC 5321.
 */

export type TesterEmailMap = Record<string, string>;

/**
 * Return the mapped tester-person name for the given Cognito email, or
 * `undefined` when no mapping exists.
 */
export function findTesterNameByEmail(
  emailMap: TesterEmailMap | undefined | null,
  email: string,
): string | undefined {
  if (!emailMap || !email) return undefined;
  const target = email.toLowerCase();
  for (const [name, mappedEmail] of Object.entries(emailMap)) {
    if (mappedEmail && mappedEmail.toLowerCase() === target) {
      return name;
    }
  }
  return undefined;
}
